module.exports = __webpack_public_path__ + "static/media/big-small.f4754b7b.webp";